export default __webpack_public_path__ + "static/media/C-PartB.8431e6b5.jpg";